
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_global.mustache";
import "../specialdays/specialdays_menu.mustache";
import "../specialdays/specialdays_empty.mustache";
const TPL = handlebars_family.addTemplate("specialdays/page_specialdays",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexcol class=\"pane-left\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"specialdays/specialdays_menu"),depth0,{"name":"specialdays/specialdays_menu","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </flexcol><flexauto class=\"pane-main \" style=\"border-left:var(--border);font-size:16px;\"> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"specialdays/specialdays_empty"),depth0,{"name":"specialdays/specialdays_empty","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " </flexauto> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_global"),depth0,{"name":"layout/layout_global","hash":{"addButton":"specialdayscreate","pageKey":"mainMenu.specialdays","isPageSpecialdays":true},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;